import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import passkeys from './passkeys'
import authenticator from './authenticator'
/**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
export const recoveryCodes = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recoveryCodes.url(options),
    method: 'get',
})

recoveryCodes.definition = {
    methods: ["get","head"],
    url: '/account/2fa/recovery-codes',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
recoveryCodes.url = (options?: RouteQueryOptions) => {
    return recoveryCodes.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
recoveryCodes.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recoveryCodes.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
recoveryCodes.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: recoveryCodes.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
    const recoveryCodesForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: recoveryCodes.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
        recoveryCodesForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: recoveryCodes.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\AccountController::recoveryCodes
 * @see app/Http/Controllers/AccountController.php:300
 * @route '/account/2fa/recovery-codes'
 */
        recoveryCodesForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: recoveryCodes.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    recoveryCodes.form = recoveryCodesForm
const twoFactor = {
    recoveryCodes: Object.assign(recoveryCodes, recoveryCodes),
passkeys: Object.assign(passkeys, passkeys),
authenticator: Object.assign(authenticator, authenticator),
}

export default twoFactor